module.exports = __webpack_public_path__ + "img/oem8.8ac30c49.png";